<template>
  <div class="main-layout" :class="fontSize">
    <header class="main-nav-wrap">
      <b-container fluid>
        <b-row>
          <b-col>
            <b-navbar id="main-nav" class="px-0" toggleable="lg" type="light" variant="white" style="margin-bottom:-6px">
              <b-navbar-brand><img src="/img/logo.png" alt="ARVID's logo" /></b-navbar-brand>

              <b-navbar-toggle target="nav-collapse" variant="primary"></b-navbar-toggle>

              <b-collapse id="nav-collapse" is-nav>
                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto">
                  <li class="nav-item visible-on-focus"><a href="#main-anchor" class="nav-link" tabindex="0" target="_self">Gå til indhold</a></li>
                  <b-nav-item to="/">Forside</b-nav-item>
                  <b-nav-item to="/search">Søgning</b-nav-item>
                  <b-nav-item to="/about">Om ARVID</b-nav-item>
                  <b-nav-item-dropdown text="Admin" right v-if="loggedIn">
                    <b-dropdown-item to="/administration">Forside</b-dropdown-item>
                    <b-dropdown-item href="./admin/request/request/overview/">Statistik</b-dropdown-item>
                    <b-dropdown-item to="/administration/reporting">Rapportering</b-dropdown-item>
                    <b-dropdown-item to="/administration/content">Indholdssektioner</b-dropdown-item>
                    <b-dropdown-item to="/administration/keywords">Taksonomi</b-dropdown-item>
                    <b-dropdown-item href="./admin/auth/">Brugere</b-dropdown-item>
                    <b-dropdown-item to="/administration/newsletter">Nyhedsbrev</b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-button variant="primary" class="mx-3" style="white-space: nowrap;" @click="addDocument()">Tilføj&nbsp;dokument</b-button>
                  </b-nav-item-dropdown>
                  <b-nav-form @submit.prevent="">
                    <b-button type="submit" @click="goToLogin()" v-if="!loggedIn" size="sm" class="my-2 text-light" variant="primary">Log ind</b-button>
                    <b-button type="submit" v-b-modal.modal-logout v-else size="sm" class="my-2 text-light" variant="primary">Log ud</b-button>
                  </b-nav-form>
                  <b-modal id="modal-logout" title="Log ud" cancel-title="Annullér" ok-title="Log ud" @ok="logout()">
                    <p class="my-4">Vil du logge ud?</p>
                  </b-modal>
                </b-navbar-nav>
              </b-collapse>
            </b-navbar>
          </b-col>
        </b-row>
        <b-row>
          <b-col style="background-color:#f6f6f6;height:40px;" class="border-bottom">
            <b-button-group class="float-right py-2 select-buttons font-size-buttons" size="xs">
              <b-button @click="setFontSize('medium')" :pressed="fontSize === 'medium'" variant="primary" style="font-size:.5rem;">
                <b-icon icon="fonts"></b-icon><span class="h6 hidden-text">Lille skriftstørrelse</span>
              </b-button>
              <b-button @click="setFontSize('large')" :pressed="fontSize === 'large'" variant="primary" style="font-size:.8rem;">
                <b-icon icon="fonts"></b-icon><span class="h6 hidden-text">Medium skriftstørrelse</span>
              </b-button>
              <b-button @click="setFontSize('x-large')" :pressed="fontSize === 'x-large'" variant="primary" style="font-size:1rem;">
                <b-icon icon="fonts"></b-icon><span class="h6 hidden-text">Stor skriftstørrelse</span>
              </b-button>
            </b-button-group>
          </b-col>
        </b-row>
      </b-container>
    </header>
    <div class="content-wrap">
      <b-container fluid style="min-height: calc(100vh - 270px)">
        <b-row>
          <b-col class="p-0">
            <main role="main" id="main">
              <div id="main-anchor" style="width: 10px; height: 10px; position: absolute; top: -134px;"></div>
              <slot></slot>
            </main>
          </b-col>
        </b-row>
      </b-container>
      <footer class="footer py-5 px-4 text-center">
        <div class="d-flex justify-content-center align-items-center">
          <img style="width:300px" class="mr-4" src="/img/star_logo_web.png" alt="Styrelsen for Arbejdsmarked og Rekruttering's logo">
          <b-overlay :show="loading" variant="dark" :opacity="0" spinner-variant="primary" spinner-small>
            <div class="mb-0 small" v-html="content"></div>
          </b-overlay>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    fontSize: 'large',
    content: null,
    loading: true,
  }),
  mounted() {
    this.getContent()
  },
  computed: {
    loggedIn() {
      return sessionStorage.getItem('user')
    }
  },
  methods: {
    setFontSize(size) {
      this.fontSize = size
    },
    logout() {
      this.$store.commit("CLEAR_USER_DATA")
    },
    addDocument() {
      let routeName = this.$router.currentRoute.name
      this.$router.push('/documents/new')
      if (routeName === 'Dokument') {
        this.$router.go()
      }
    },
    goToLogin() {
      this.$router.push({name: 'Login', params: {page: this.$route.path}})
    },
    getContent() {
      let config = this.$store.getters.getConfig
      this.axios.get('/api/sections/footer/', config).then((response) => {
        this.content = response.data.content
        this.loading = false
      }).catch(error => {
        console.error(error)
        this.loading = false
      })
    },
  }
}
</script>

<style>
  .visible-on-focus a {
    opacity: 0;
    height: 0px;
    overflow: hidden;
  }

  .visible-on-focus a:focus,
  .visible-on-focus a:focus-visible {
    opacity: 1;
    height: auto;
  }

  .footer {
    background-color: #f1f0ef;
    height: 120px;
    margin-top: 40px;
  }

  .footer p {
    margin-bottom: 0;
  }
</style>